import { render, staticRenderFns } from "./ApplayForm.vue?vue&type=template&id=64b4fcee&scoped=true"
import script from "./ApplayForm.vue?vue&type=script&lang=js"
export * from "./ApplayForm.vue?vue&type=script&lang=js"
import style0 from "./ApplayForm.vue?vue&type=style&index=0&id=64b4fcee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4fcee",
  null
  
)

export default component.exports